<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_2"></a><strong>GOT SO MUCH CHIPS, I SWEAR THEY CALL ME HEWLETTPACKARD</strong></h3>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“LOLLIPOP (REMIX)”</strong> ON ALBUM: <strong>THA CARTER III (ITUNES BONUS TRACK)</strong> BY ARTIST</span>: <strong>LIL WAYNE</strong></p>
<p class="noindent">I am so wealthy that people might mistakenly refer to me by the name of a large multinational computer manufacturer whose integrated circuits are commonly referred to by the same name that I and others use for money.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch01.vue?1a20cc56